import PropTypes from 'prop-types'
// biome-ignore lint/correctness/noUnusedImports: Required for SSR compatibility
import React from 'react'
import usePreventPullToRefresh from '../../../hooks/usePreventPullToRefresh'
import { isiOS } from '../../../utils/mobileAppFunctionality'
import { SwipeDetector } from '../swipeDetector'

// The swipe distance threshold (130px) was chosen based on user experience testing
// to ensure a balance between responsiveness and avoiding accidental swipes.
const CUSTOM_SWIPE_DISTANCE = 130

const PreventRefreshSwipeHandler = ({
  onSwipeDown,
  children,
  skipPreventRefreshOnIOS = false,
  customSwipeDistance,
}) => {
  const shouldPrevent = !(skipPreventRefreshOnIOS && isiOS())

  usePreventPullToRefresh(shouldPrevent)

  return (
    <SwipeDetector
      onSwipeDown={onSwipeDown}
      minSwipeDistance={customSwipeDistance ?? CUSTOM_SWIPE_DISTANCE}
    >
      {children}
    </SwipeDetector>
  )
}

PreventRefreshSwipeHandler.propTypes = {
  onSwipeDown: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  skipPreventRefreshOnIOS: PropTypes.bool,
}

export { PreventRefreshSwipeHandler }
